import { useGetAppTrackingStatsQuery } from '@app/services';
import { selectCurrentUser } from '@app/store/selectors';
import { useAppSelector } from '@common';
import { DateFormat, _compact, useGetSearchParamValue } from '@common';
import { AppTracking } from '@common';
import { TableColumnsType } from 'antd';
import dayjs from 'dayjs';
import duration from 'dayjs/plugin/duration';
import relativeTime from 'dayjs/plugin/relativeTime';

dayjs.extend(duration);
dayjs.extend(relativeTime);

export function useVisitorStatsTable(id?: string) {
    const user = useAppSelector(selectCurrentUser);
    const queryId = useGetSearchParamValue('app');
    const appId = id || queryId;
    const { currentData, isFetching } = useGetAppTrackingStatsQuery(appId, { skip: !appId || !user?.id });

    const columns: TableColumnsType<AppTracking> = [
        {
            key: 'user',
            dataIndex: ['user', 'userName'],
            title: 'User',
            render: (value, record) => {
                if (value) return value;
                if (record.sharingName) return `Sharing: ${record.sharingName}`;
                return 'Anonymous';
            },
        },

        {
            key: 'geoLocation',
            dataIndex: 'geoLocation',
            title: 'Geo Location',
            render: (value: AppTracking['geoLocation']) => (value ? _compact([value.city, value.country]).join(', ') : ''),
        },
        {
            key: 'createdAt',
            dataIndex: 'createdAt',
            title: 'Date & Time',
            // createdAt/updatedAt are stored as ms (Date.now()), not unix seconds
            render: value => dayjs(value).format(DateFormat.Default),
        },
        {
            key: 'sessionDuration',
            title: 'Session Duration',
            // ponytail: derived from the row, the API never sends sessionDuration
            render: (_, record) => dayjs.duration(record.updatedAt - record.createdAt).humanize(),
        },
    ];

    return {
        data: currentData,
        columns,
        isFetching,
    };
}
